import { Box, Card, Checkbox, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type LeaveForm from 'modules/timeoff/lib/LeaveForm'

interface Props {
  form: LeaveForm
}

const NewEauRequest = ({ form }: Props) => {
  return (
    <Card>
      <Card.Title size="small">{i18n.t('time_off.eau_confirmation.form.title')}</Card.Title>
      <Card.Content>
        <Box gap="s8">
          <Text.Normal color="grey800">
            {i18n.t('time_off.eau_confirmation.form.description')}
          </Text.Normal>
          <Text.Normal color="grey800">
            {i18n.t('time_off.eau_confirmation.form.lauds_warning')}
          </Text.Normal>

          <Box paddingTop="s12">
            <Checkbox
              checked={form.get('skip_eau_check').value}
              onChange={(event) => form.get('skip_eau_check').set(event.target.checked)}
              size="small"
              label={i18n.t('time_off.eau_confirmation.form.skip_eau_check')}
            />
          </Box>
        </Box>
      </Card.Content>
    </Card>
  )
}

export default NewEauRequest
